import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useApiGet } from '../../utils/httpClientTs';
import { getMyPermissions } from '../../endpoints/usersTs';
import { hasUserApplicationPermission } from '../../utils/permissions';

/** Soft-launch gate for Membership Resources hub. */
export const CanViewMembershipResources: React.FC = () => {
  const { data: permissions, isLoading } = useApiGet<string[]>(
    ['my-permissions-membership-resources'],
    () => getMyPermissions({ international: '1' }),
    { enabled: true, retry: 1 }
  );

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  const canAccess = hasUserApplicationPermission(
    permissions,
    'membership:resources'
  );
  return canAccess ? <Outlet /> : <Navigate to="/" replace />;
};

export default CanViewMembershipResources;
